import { useQuery } from '@tanstack/react-query'
import { stringify } from 'qs'

import { apiClient } from '../../apiClient'

type TasksIds = {
  taskReviewId: string
  taskId: string
}

type QueryRetry = boolean | number | ((failureCount: number, error: unknown) => boolean)

export function useGetByIds(taskIds: string[], disabled?: boolean, options?: { retry?: QueryRetry }) {
  return useQuery<TasksIds[], Error>({
    queryKey: ['tasksReviewIds', taskIds],
    queryFn: async () => {
      const { data } = await apiClient.get(`/int/v3/operators/task-review/by-task-ids`, {
        params: { taskIds },
        paramsSerializer: (params) => stringify(params, { arrayFormat: 'repeat' }),
      })
      return data
    },
    enabled: Boolean(taskIds.length > 0) && !disabled,
    retry: options?.retry,
  })
}
